$(function(){
	setupTheoryTests();
})

function setupTheoryTests() {
	$('#questionsForm').submit(function(e) {
		e.preventDefault();
		var hasErrors = false;
		
		var selectedAnswers = $('.answer.selected', this);
		var questionsCount = $('.question').length;
		
		$('#messages').html('').removeClass('text-orange text-green text-red');
		selectedAnswers.each(function(e) {
			if ($(this).attr('data-correct-answer')) {
				$(this).parent('.answers').addClass('correct');
				$('#messages').addClass('text-green').html(localizedTexts.dev.rightAnswers);
			}
			else {
				$(this).parent('.answers').addClass('incorrect');
				$('#messages').addClass('text-red').html(localizedTexts.dev.almostRightAnswer);
				hasErrors = true;
			}
		});

		if (selectedAnswers.length < questionsCount) {
			$('#messages').addClass('text-orange').html(localizedTexts.dev.checkRightAnswer);
			
			return;
		}

		
		// change the submit button (either replace with the "continue" button, or just replace the caption)
		var submitButton = $('input[type=submit]', this);
		if (!hasErrors) {
			submitButton.hide();
			$('#btn-continue')
				.removeClass('hide')
				.css('display', 'inline-block');

			var redirectTo = $(this).attr('action');
			$.post('?do=completeTheory', []);	 // like this, because e.preventDefault() was called before
		}
		else {
			$('input[type=submit]', this).data('originalCaption', submitButton.attr('value'));
			submitButton.attr('value', localizedTexts.dev.tryAgain).addClass('tryAgain');
		}
	});

	$('.answer').click(function() {
		$(this).parent('.answers').removeClass('correct incorrect');
		$(this).parent('.answers').find('.answer').removeClass('selected');
		$(this).addClass('selected');

		if ($('.answer.selected', this).length == $('.question').length) {
			$('#messages').html('').removeClass('text-orange text-green text-red');
		}

		var submitButton = $('input[type=submit]', '.questionsForm');
		if (submitButton.data('originalCaption')) {
			submitButton.attr('value', submitButton.data('originalCaption')).removeClass('tryAgain');
		}
	});
}